export const TOGGLE_SUGGESTIONS = Symbol('TOGGLE_SUGGESTIONS')
export const DIFF_SETTING_CHANGED = Symbol('DIFF_SETTING_CHANGED')
export const SET_SUGGESTION_SEARCH_TYPE = Symbol('SET_SUGGESTION_SEARCH_TYPE')
export const RESET_SUGGESTIONS_COPYING = Symbol('RESET_SUGGESTIONS_COPYING')
// FIXME may be unused
export const COPY_SUGGESTION_N = Symbol('COPY_SUGGESTION_N')
export const COPY_SUGGESTION = Symbol('COPY_SUGGESTION')
export const TEXT_SUGGESTION_STARTED_COPYING =
Symbol('TEXT_SUGGESTION_STARTED_COPYING')
export const TEXT_SUGGESTION_FINISHED_COPYING =
  Symbol('TEXT_SUGGESTION_FINISHED_COPYING')
export const PHRASE_SUGGESTION_STARTED_COPYING =
  Symbol('PHRASE_SUGGESTION_STARTED_COPYING')
export const PHRASE_SUGGESTION_FINISHED_COPYING =
  Symbol('PHRASE_SUGGESTION_FINISHED_COPYING')
export const TEXT_SUGGESTIONS_UPDATED = Symbol('TEXT_SUGGESTIONS_UPDATED')
export const SUGGESTION_SEARCH_TEXT_CHANGE =
  Symbol('SUGGESTION_SEARCH_TEXT_CHANGE')
export const PHRASE_SUGGESTIONS_UPDATED = Symbol('PHRASE_SUGGESTIONS_UPDATED')
export const SUGGESTION_PANEL_HEIGHT_CHANGE =
  Symbol('SUGGESTION_PANEL_HEIGHT_CHANGE')
export const SHOW_DETAIL_FOR_SUGGESTION_BY_INDEX =
  Symbol('SHOW_DETAIL_FOR_SUGGESTION_BY_INDEX')



// WEBPACK FOOTER //
// ./app/editor/actions/suggestions-action-types.js